// Translated UI wrapper for period naming.
// Worker uses the plain-logic version: server/worker/util/getPeriodLabel.ts
import i18n from "./i18n.ts";

export const getPeriodName = (numPeriods: number, short?: boolean): string => {
	const ns = "ui";

	if (numPeriods === 2) {
		return short
			? i18n.t("periodName.half_short", { ns, defaultValue: "H" })
			: i18n.t("periodName.half_long", { ns, defaultValue: "half" });
	}

	if (numPeriods === 4) {
		return short
			? i18n.t("periodName.quarter_short", { ns, defaultValue: "Q" })
			: i18n.t("periodName.quarter_long", { ns, defaultValue: "quarter" });
	}

	return short
		? i18n.t("periodName.period_short", { ns, defaultValue: "P" })
		: i18n.t("periodName.period_long", { ns, defaultValue: "period" });
};
